import styled from "styled-components";

export const PageControlsContainer = styled.div`
  display: flex;
  justify-content: space-between;
`
export const ProjectControls = styled.div`
  display: flex;
  gap: 1rem;
  height: 2rem;
`
interface ControlButtonProps {
  label: string;
}

export const ControlButton = styled.button<ControlButtonProps>`
  position: relative;
  color: ${({ theme }: {theme: any}) => theme.themePrimary};
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: transparent;
  cursor: pointer;

  &:hover::before {
    opacity: 1;
    visibility: visible;
  }

  &::before {
    content: ${({ label }: {label: any}) => '"' + label + '"'};
    position: absolute;
    top: calc(100% + 0.1rem);
    left: 50%;
    transform: translateX(-50%);
    opacity: 0;
    visibility: hidden;
    font: 500 0.7rem/0.9rem 'Roboto', sans-serif;
    text-align: center;
    background: ${({theme}: {theme: any}) => theme.white};
    padding: 0.2rem 0.5rem;
    border-radius: 0.5rem;
    z-index: 2000;
    transition: all 0.3s ease;
  }
`